// src/utils/dateUtils.ts
export const formatDate = (dateString?: string) => {
  if (!dateString) {
    return 'N/A';
  }
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
